module.exports = __webpack_public_path__ + "img/Documentation.efb95ba6.svg";